import React from 'react';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { withRouter } from 'react-router-dom';
import UiShared from 'stores/UiShared';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';

@withRouter
@inject(root => ({
	uiShared: root.uiShared,
	user: root.auth.user
}))
@observer
export default class Profile extends React.Component {
	props: {
		uiShared?: UiShared,
		user?: Account
	};

	@observable
	passwordChange = {
		oldPassword: '',
		newPassword: '',
		newPasswordConfirm: ''
	};

	msgStore: MsgStore = new MsgStore();

	updatePassword = async () => {
		const uiShared = this.props.uiShared;
		try {
			this.msgStore.clear();
			uiShared.showSpinner('Updating password...');
			await this.props.user.changePassword(this.passwordChange);
			this.msgStore.setInfo('Your password was updated.');
		} catch (err) {
			this.msgStore.setError(err);
		} finally {
			uiShared.hideModal();
		}
	};

	render() {
		const passwordChange = this.passwordChange;

		return (
			<Segment>
				<Header as="h1">Profile</Header>

				<h3>Change password</h3>
				<Form>
					<Form.Input
						type="password"
						label="Old password"
						value={passwordChange.oldPassword}
						onChange={e => (passwordChange.oldPassword = e.target.value)}
						width={4}
					/>
					<Form.Input
						type="password"
						label="New password"
						value={passwordChange.newPassword}
						onChange={e => (passwordChange.newPassword = e.target.value)}
						width={4}
					/>
					<Form.Input
						type="password"
						label="Re-type new password"
						value={passwordChange.newPasswordConfirm}
						onChange={e => (passwordChange.newPasswordConfirm = e.target.value)}
						width={4}
					/>
					<MessageBox msgStore={this.msgStore} />
					<Form.Field>
						<Button primary onClick={() => this.updatePassword()}>
							Save
						</Button>
					</Form.Field>
				</Form>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/User/Profile/index.js